// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
}
:host .image-input-wrap .image-placeholder {
  display: none;
}
:host .image-input-wrap.value-exists {
  margin-top: 12px;
  margin-bottom: 8px;
  width: 240px;
  height: 180px;
}
:host .image-input-wrap.value-exists ion-label {
  transform: none !important;
  font-size: 13px;
}
:host .image-input-wrap.value-exists img {
  margin-top: 10px;
  border: 1px solid var(--ion-color-lighter-contrast);
  width: 240px;
  height: 160px;
  margin: 0 auto;
  object-fit: cover;
}
:host .icon {
  align-self: flex-end;
  position: relative;
  top: -8px;
  height: 20px;
  z-index: 9999;
}
:host .icon ion-icon[name=camera] {
  background: rgba(255, 255, 255, 0.5);
  padding: 10px;
  font-size: 20px;
  color: var(--ion-color-secondary-tint);
}
:host .icon.value-exists {
  top: -16px;
}
:host .label-wrap {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/image-input/image-input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AACF;AAGI;EACE,aAAA;AADN;AAmCE;EACE,gBAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;AAlCJ;AAmCI;EACE,0BAAA;EACA,eAAA;AAjCN;AAmCI;EACE,gBAAA;EACA,mDAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAjCN;AAuCE;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;AArCJ;AAuCI;EACE,oCAAA;EACA,aAAA;EACA,eAAA;EACA,sCAAA;AArCN;AAuCI;EACE,UAAA;AArCN;AAwCE;EACE,aAAA;AAtCJ","sourcesContent":[":host {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  min-height: 40px;\r\n  // border-bottom: 1px solid var(--ion-border-color);\r\n\r\n  .image-input-wrap {\r\n    .image-placeholder {\r\n      display: none;\r\n      // border: 1px solid var(--ion-color-lighter-contrast);\r\n      // width: 100%;\r\n      // text-align: center;\r\n      // font-size: 80px;\r\n      // height: 160px;\r\n      // .icon-photo_camera:before {\r\n      //   color: var(--ion-color-lighter-light);\r\n      //   content: \"\\e412\";\r\n      //   font-size: 80px;\r\n      //   line-height: 160px;\r\n      // }\r\n    }\r\n    //   &.always-show-placeholder {\r\n    //     .image-placeholder {\r\n    //       display:block;\r\n    //       border: 1px solid var(--ion-color-lighter-contrast);\r\n    //       width: 100%;\r\n    //       text-align: center;\r\n    //       font-size: 80px;\r\n    //       // height: 160px;\r\n    //       margin-bottom: 8px;\r\n    //       width: 240px;\r\n    //       height: 180px;\r\n    //       .icon-photo_camera:before {\r\n    //         color: var(--ion-color-lighter-light);\r\n    //         content: \"\\e412\";\r\n    //         font-size: 80px;\r\n    //         line-height: 160px;\r\n    //       }\r\n    //     }\r\n    //   }\r\n  }\r\n\r\n  .image-input-wrap.value-exists {\r\n    margin-top: 12px;\r\n\r\n    margin-bottom: 8px;\r\n    width: 240px;\r\n    height: 180px;\r\n    ion-label {\r\n      transform: none !important;\r\n      font-size: 13px;\r\n    }\r\n    img {\r\n      margin-top: 10px;\r\n      border: 1px solid var(--ion-color-lighter-contrast);\r\n      width: 240px;\r\n      height: 160px;\r\n      margin: 0 auto;\r\n      object-fit: cover;\r\n    }\r\n  }\r\n\r\n  ion-label {\r\n  }\r\n  .icon {\r\n    align-self: flex-end;\r\n    position: relative;\r\n    top: -8px;\r\n    height: 20px;\r\n    z-index: 9999;\r\n\r\n    ion-icon[name=\"camera\"] {\r\n      background: rgba(255, 255, 255, 0.5);\r\n      padding: 10px;\r\n      font-size: 20px;\r\n      color: var(--ion-color-secondary-tint);\r\n    }\r\n    &.value-exists {\r\n      top: -16px;\r\n    }\r\n  }\r\n  .label-wrap {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
